import CustomerLogin from './Customer_Login.js';
import './Customerlogin.css'
import Corousal from "./Crousal.js";
 
 
const CusomerLoginButton = () => {
  return (
      <div className='background'>
        <div className="Subcontainer">
          <div className='loginRightContainer' >
              <Corousal />
          </div>
          <div className='loginLeftContainer'>
            <CustomerLogin />
          </div>
        </div>
      </div>)
}
export default CusomerLoginButton;
 